import { DataKindMaintenancePageState } from ".";
import { GetDataKind } from "../../services/data-kinds";

export const displayColumn = [
  { label: "Data Kind ID", value: "dtKindId" },
  { label: "Data Kind Name", value: "dtKindNameLclLang" },
  { label: "Data Kind Name(ENG)", value: "dtKindNameEng" },
];

export type DataKindKeys = keyof GetDataKind;

export const DataKindMaintenancePageInitialState: DataKindMaintenancePageState =
  {
    isSaved: true,
    searchResult: {
      dataKindList: [
        // {
        //   addFlg: InDefCommonFlagType.YES,
        //   isEdited: true,
        //   getDataKind: {
        //     delFlg: InDefCommonFlagType.NO,
        //     dtKindId: "",
        //     mltcstDsbldFlg: InDefCommonFlagType.NO,
        //     dtKindNameLclLang: "",
        //     dtKindNameEng: "",
        //     dtKindNameWtngChngLclLang: "",
        //     dtKindNameWtngChngEng: "",
        //     updateDateTime: "",
        //   },
        // },
        // {
        //   addFlg: InDefCommonFlagType.YES,
        //   isEdited: true,
        //   getDataKind: {
        //     delFlg: InDefCommonFlagType.NO,
        //     dtKindId: "",
        //     mltcstDsbldFlg: InDefCommonFlagType.NO,
        //     dtKindNameLclLang: "",
        //     dtKindNameEng: "",
        //     dtKindNameWtngChngLclLang: "",
        //     dtKindNameWtngChngEng: "",
        //     updateDateTime: "",
        //   },
        // },
      ],
    },
    spreadsheetSelectedRowIndex: undefined,
    dataList: {
      inDefCommonFlagType: [],
    },
    displayColumn: displayColumn,
  };
